/** 日期组件 */
import './index.scss'
import React from 'react'
import {Button, DatePicker} from 'antd'
import { DownOutlined } from '@ant-design/icons';
import moment from "moment";
const { RangePicker } = DatePicker;

class Index extends React.Component {
  // 标记位 是否是自定义
  isCustomize = null;
  state = {
    value: '',
    startTime: '',
    endTime: '',
    rangeOpen: false,
    showOptions: false,
    optionList:[{
      key: 30,
      unit: 'minutes',
      val: '30分钟'
    }, {
      key: 4,
      unit: 'hours',
      val: '4小时'
    }, {
      key: 24,
      unit: 'hours',
      val: '24小时'
    }, {
      key: 3,
      unit: 'days',
      val: '3天'
    }, {
      key: 7,
      unit: 'days',
      val: '7天'
    }, {
      key: 1,
      unit: 'months',
      val: '1个月'
    }, {
      key: 0,
      unit: 'days',
      val: '今天'
    }, {
      key: 1,
      unit: 'days',
      nowTime: false,
      val: '昨天'
    }, {
      key: 0,
      unit: 'weeks',
      val: '本周'
    }, {
      key: 0,
      unit: 'months',
      val: '本月'
    }, {
      key: 1,
      unit: 'months',
      nowTime: false,
      val: '上月'
    }, {
      key: null,
      val: '自定义'
    }]
  };
  componentDidMount() {
    const {value, startTime, endTime} = this.props;
    // 默认值
    const {optionList} = this.state;
    if (value && value !== '自定义') {
      this.setState({
        value
      })
      const LEN = optionList.length;
      for(let i = 0; i < LEN; i++) {
        if (value === optionList[i].val) {
          this.getTime(optionList[i]);
          return;
        }
      }
    } else if(value === '自定义') {
      this.handleDateRange(null, [moment(startTime).format('YYYY-MM-DD HH:mm'), moment(endTime).format('YYYY-MM-DD HH:mm')]);
    }
  };
  // 日期区间
  disabledDate = (current) => {
    return current && (current < moment().subtract(3, 'months') || current > moment().endOf('day'));
  };
  handleOptions = (val) => {
    this.setState({
      rangeOpen: val
    });
    // 和日期面板一起隐藏
    setTimeout(() => {
      this.setState({
        showOptions: val
      })
    }, 300)
  };
  // btn group
  setOptions = () => {
    return this.state.optionList.map(item => {
      return <Button key={item.val} onClick={() => this.getTime(item)} type={item.val === this.state.value ? 'primary' : 'default'}>{item.val}</Button>
    })
  };
  // 时间按钮
  getTime(timeData) {
    // 自定义没有时间
    if (!timeData.unit) {
      this.setState({
        value: '自定义',
      });
      this.isCustomize = true;
      return;
    }
    let startTime;
    let endTime;
    if (timeData.key) {
      if (timeData.nowTime == null) {
        startTime = moment().subtract(timeData.key, timeData.unit).format('YYYY-MM-DD HH:mm');
        endTime = moment().format('YYYY-MM-DD HH:mm');
      } else {
        switch (timeData.unit) {
          case "days": // 昨天
            startTime = moment().subtract(timeData.key, timeData.unit).format('YYYY-MM-DD 00:00');
            endTime = moment().format('YYYY-MM-DD 00:00');
            break;
          case "months": // 上个月
            startTime = moment().month(moment().month() - 1).startOf('month').format('YYYY-MM-DD 00:00');
            endTime = moment().startOf("month").format('YYYY-MM-DD 00:00');
            break;
          default:
        }
      }
    } else {
      switch (timeData.unit) {
        case "days": // 今天
          startTime = moment().startOf("day").format('YYYY-MM-DD 00:00');
          break;
        case "weeks": // 本周
          startTime = moment().startOf("week").format('YYYY-MM-DD 00:00');
          break;
        case "months": // 本月
          startTime = moment().startOf("month").format('YYYY-MM-DD 00:00');
          break;
        default:
      }
      endTime = moment().format('YYYY-MM-DD HH:mm');
    }
    this.setState({
      value: timeData.val,
      startTime,
      endTime,
    });
    this.props.handleDateTimePicker(timeData.val, `${startTime}:00`, `${endTime}:00`);
    this.handleOptions(false);
  };
  // 日期改变
  handleDateRange = (moment, string) => {
    if (!string[0] || !string[1]) return;
    this.setState({
      value: '自定义',
      startTime: string[0],
      endTime: string[1]
    });
    this.props.handleDateTimePicker('自定义', `${string[0]}:00`, `${string[1]}:00`);
    this.handleOptions(false);
  };
  closeOptions = () => {
    setTimeout(() => {
      this.isCustomize ? this.isCustomize = null : this.handleOptions(false);
    }, 200)
  };
  render() {
    const {value, showOptions, rangeOpen, startTime, endTime} = this.state;
    const {comClassName} = this.props;
    return (
      <div className={comClassName ? `com-date-time ${comClassName}` : 'com-date-time'}>
        <div className='time-select' onClick={() => this.handleOptions(true)}>{value}<DownOutlined /></div>
        <div className='sec-option' style={{display: showOptions ? 'block' : 'none'}}>
          {this.setOptions()}
          <RangePicker
            value={[moment(startTime || undefined), moment(endTime || undefined)]}
            disabledDate={this.disabledDate}
            open={rangeOpen}
            showTime={true}
            format="YYYY-MM-DD HH:mm"
            onOpenChange={() => this.closeOptions()}
            onChange={(moment, string) => this.handleDateRange(moment, string)}/>
        </div>
      </div>
    );
  }
}

export default Index
